import { ORDER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';
import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const columns: ColumnInterface[] = [
  {
    title: 'Порядок отображения групп контроля',
    key: 'ctrl_group_order',
    orderBy: {
      type: ORDER.ASC,
      order: 1,
      isNullsFirst: false,
    },
  },
  {
    title: 'Код группы контролей',
    key: 'ctrl_group_code',
  },
  {
    title: 'Наименование группы контролей',
    key: 'ctrl_group_name',
  },
];
